import {Button, Icon, Popup} from '@gravity-ui/uikit';
import {CircleRuble} from '@gravity-ui/icons';
import {usePopoverAuxControls} from '@frontend/shared';
import {BalanceElement} from '../BalanceElement/BalanceElement';

export const MobileBalanceButton = () => {
    const {open, buttonRef, toggleOpen, closePopover} = usePopoverAuxControls();

    return (
        <div>
            <Button view="normal" size="m" selected={open} ref={buttonRef} onClick={toggleOpen}>
                <Icon data={CircleRuble} width={16} height={16} />
            </Button>

            <Popup
                anchorRef={buttonRef}
                onClose={closePopover}
                open={open}
                placement="bottom-start"
                hasArrow
                style={{borderRadius: '8px'}}
            >
                <BalanceElement closePopover={closePopover} />
            </Popup>
        </div>
    );
};
